import { UNIT_REGEX } from '../common.mjs';

function parseValue(token, unit = '', rootSize = 1) {
    const isNumber = typeof token === 'number';
    const defaultUnit = unit;
    // 如果是純數字
    if (isNumber) {
        return {
            unit: defaultUnit,
            type: 'number',
            value: defaultUnit === 'rem' || defaultUnit === 'em' ? token / rootSize : token
        };
    }
    const matches = token.match(UNIT_REGEX);
    if (matches) {
        let value = parseFloat(matches[1]);
        let parsedUnit = matches[2] || '';
        if (!parsedUnit && (defaultUnit === 'rem' || defaultUnit === 'em')) {
            value = value / rootSize;
            parsedUnit = defaultUnit;
        }
        return {
            token,
            value,
            unit: parsedUnit || defaultUnit,
            type: 'number'
        };
    }
    // 無法解析則當作純字串
    return {
        token,
        value: token,
        type: 'string'
    };
}

export { parseValue as default };
